module.exports = __webpack_public_path__ + "9f1ceb81bcf3a75e081ca053094077a7.svg";